var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNumberTwoBluedashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 3,
    fill: "#5463FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6113 16.7969H8.99805V15.9824L11.2891 13.6562C11.7148 13.2266 12.0723 12.8438 12.3613 12.5078C12.6543 12.1719 12.877 11.8418 13.0293 11.5176C13.1816 11.1895 13.2578 10.8301 13.2578 10.4395C13.2578 9.95508 13.1133 9.58594 12.8242 9.33203C12.5391 9.07422 12.1621 8.94531 11.6934 8.94531C11.2832 8.94531 10.9199 9.01562 10.6035 9.15625C10.2871 9.29688 9.96289 9.49609 9.63086 9.75391L9.10938 9.09766C9.33594 8.90625 9.58203 8.73633 9.84766 8.58789C10.1172 8.43945 10.4043 8.32227 10.709 8.23633C11.0176 8.15039 11.3457 8.10742 11.6934 8.10742C12.2207 8.10742 12.6758 8.19922 13.0586 8.38281C13.4414 8.56641 13.7363 8.82812 13.9434 9.16797C14.1543 9.50781 14.2598 9.91211 14.2598 10.3809C14.2598 10.834 14.1699 11.2559 13.9902 11.6465C13.8105 12.0332 13.5586 12.418 13.2344 12.8008C12.9102 13.1797 12.5312 13.582 12.0977 14.0078L10.2344 15.8652V15.9062H14.6113V16.7969Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberTwoBluedashboard);
export default __webpack_public_path__ + "static/media/NumberTwoBlue.dashboard.a48d05f17183c9b28a30bccb0d26ba79.svg";
export { ForwardRef as ReactComponent };